import { useEffect } from 'react';
import useFocusedElement from '../../hooks/useFocusedElement';
/** Extra hook to correct loss of focus when an element in the modal is focused and then
 * that element is unmounted, sending focus to <body> instead of the modal.
 *
 * This is a bug with AntD so the fix is a little bodgy, but should be unnecessary once
 * we start using <dialog> instead
 */
export default function useRectifyModalFocus(enabled = false) {
    const focusedElement = useFocusedElement();
    const needsRectifying = enabled && !(focusedElement === null || focusedElement === void 0 ? void 0 : focusedElement.closest('.ant-modal'));
    useEffect(() => {
        if (needsRectifying) {
            // focus has gone outside the modal! return it!
            const newFocusTarget = window.document.querySelector('.ant-modal > [tabindex="0"]');
            newFocusTarget === null || newFocusTarget === void 0 ? void 0 : newFocusTarget.focus();
        }
    }, [needsRectifying]);
}
//# sourceMappingURL=useRectifyModalFocus.js.map